import React, { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import CustomDropdown from "../../CustomControls/dropdown";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import ErrorModal from "../Security/ErrorModal";

const BHAssessmentForm = () => {
  const [dropdownValues, setDropdownValues] = useState([]);
  const [formData, setFormData] = useState({
    freetext: "",
    interest: "",
    depressed: "",
    trobulesleep: "",
    tired: "",
    overeating: "",
    feelingbad: "", 
    troubleconcentrating: "", 
    Movingspeakingslowly: "", 
    hurtingyourself: "",
    nervous: "",
    controlworrying: "",
    worrying: "",
    troublerelaxing: "",
    restless: "",
    afraid: "",
    annoyed: "",
  });
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = typeof window != "undefined" && /Android|iPhone|iPod|iPad/i.test(navigator.userAgent)
  const [errors, setErrors] = useState({});
  const token = localStorage.getItem("AccessToken");
  const contract = useSelector((state) => state.userData);
  const { t, i18n } = useTranslation();
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const serviceDescription = location.state?.servicedescription || "";
  const [modalMessageHeader,setModalMessageHeader] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [consultationTypes, setConsultationTypes] = useState([]);
  const [showFetchErrorModal, setShowFetchErrorModal] = useState(false);
  const [fetchErrorMessage, setFetchErrorMessage] = useState("")
  const [showCallBtn, setShowCallBtn] = useState(false)
  
  const fetchDropdownValues = async () => {
    const params = { MemberID: contract.userData.MemberID, Contract: contract.userData.ContractIdentified };

    try {
      const response = await axios.post(
        Endpoints.BHAssessment,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        setDropdownValues(response.data); // Adjust as per the response structure
      }
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  const fetchConsultationTypes = async () => {
      try {
        const response = await axios.post(Endpoints.fetchConsultationTypes,{
          _params: JSON.stringify({
            ServiceDescription: serviceDescription,
            Contract: contract.userData.ContractIdentified,
            EmailID: contract.userData.EmailID,
            DeviceType: "PatientPortal",
          })},
          {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

        if (response.data) {
          console.log(response.data)
          setConsultationTypes(response.data); // Assuming the response has the list of consultation types
        if (!Array.isArray(response.data) && response.data.length ===0) {
     setFetchErrorMessage("Failed to fetch consults, try launching the application again");
  setShowFetchErrorModal(true);
    }
        } else {
          console.error(response.statusText);
          setFetchErrorMessage("Failed to fetch consults, try launching the application again");
  setShowFetchErrorModal(true);
        }
      } catch (error) {
        console.error(error);
        setFetchErrorMessage("Failed to fetch consults, try launching the application again");
  setShowFetchErrorModal(true);
      }
    };

  useEffect(() => {
    fetchDropdownValues();
    fetchConsultationTypes();
  }, []);

  const handleDropdownChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
        [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    const fieldsToIgnore = ["trobulesleep", "tired", "overeating", "feelingbad", "troubleconcentrating", "Movingspeakingslowly", "hurtingyourself"]
    Object.keys(formData).forEach((key) => {
      const shouldIgnore = !isHighmarkPortal && fieldsToIgnore.includes(key);
      if (!shouldIgnore && !formData[key]) {
        newErrors[key] = t("BhValidation");
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
const getScore = (value) => {
  if (!value) return 0;

  switch (value.trim()) {
    case "Nearly every day":
      return 3;
    case "More than half the days":
      return 2;
    case "Several days":
      return 1;
    case "Not at all":
      return 0;
    default:
      return 0;
  }
};

const handlePopUp = (e) => {
  e.preventDefault()
  if (!validateForm()) {
    setShowModal(false);
    setShowCallBtn(false);
    return
  };
  console.log("isMobile:", isMobile)
  const phq9Keys = [ "interest", "depressed", "trobulesleep", "tired", "overeating", "feelingbad", "troubleconcentrating", "Movingspeakingslowly", "hurtingyourself" ]; 
  // Remaining 7 (GAD-7) 
const gad7Keys = [ "nervous", "controlworrying", "worrying", "troublerelaxing", "restless", "afraid", "annoyed" ]; 
let phq9Score = 0; 
let gad7Score = 0; // Calculate PHQ-9 
const isBehavioralHealthSelected = consultationTypes.includes("Behavioral Health")
const minValue = isHighmarkPortal ? 5 : 3
for (let i = 0; i < phq9Keys.length; i++) { 
  phq9Score += getScore(formData[phq9Keys[i]]); 
} // Calculate GAD-7 
for (let i = 0; i < gad7Keys.length; i++) { 
  gad7Score += getScore(formData[gad7Keys[i]]); 
} 
   console.log('PHQ9: %d', phq9Score, 'GAD7: %d', gad7Score)
    //toast.success(`PHQ9: ${phq9Score}, GAD7: ${gad7Score}`);
    //navigate(-1);
    if (phq9Score >= minValue && gad7Score >= 8) {
      setModalMessage("We are sorry to hear you are feeling down. We will make sure to discuss your behavioral health and/or EAP resources at your consult. The National Suicide Prevention Lifeline is also always available at 988 by chat, text, or phone.");
      setShowCallBtn(true && isMobile)
      setShowModal(true);
    } else if (phq9Score >= minValue) {
      setModalMessage(isBehavioralHealthSelected ? 
        `We are sorry to hear you are feeling down. We would love to have our ${isHighmarkPortal ? "" : "WIN"} Behavioral Care team speak with you. Please schedule a consult. The National Suicide Prevention Lifetime is also always available at 988 by chat, text, or phone.` :
        "We are sorry to hear you are feeling down. We will make sure to discuss your behavioural health and/or EAP resource at your consult. The National Suicide Prevention Lifeline is also always available at 988 by chat, text, or phone.");
      setShowCallBtn(true && isMobile);
      setShowModal(true);
    } else if (gad7Score >= 8) {
      setModalMessage(isBehavioralHealthSelected ?
        `We are sorry to hear you are feeling anxiety or feeling like you are worrying more than feels comfortable. We would love to have our ${isHighmarkPortal ? "" : "WIN"} Behavioral Health Care team speak with you. Please schedule a consult.` :
        "We are sorry to hear you are feeling anxiety or feeling like you are worrying more than feels comfortable. We wil make sure to discuss your behavioral health and/or EAP resources at your consult.");
      setShowModal(true);
    } else {
      handleSubmit(e);
    }    
}
  const handleSubmit = async (e) => {
    e.preventDefault();

    const params = {
      MemberID: contract.userData.MemberID,
      Contract: contract.userData.ContractIdentified,
      ...formData,
    };

    try {
      const response = await axios.post(
        Endpoints.BHAssessmentSave,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        toast.success("Details saved successfully");
        setFormData({
          freetext: "",
          interest: "",
          depressed: "",
          trobulesleep: "",
          tired: "",
          overeating: "",
          feelingbad: "", 
          troubleconcentrating: "", 
          Movingspeakingslowly: "", 
          hurtingyourself: "",
          nervous: "",
          controlworrying: "",
          worrying: "",
          troublerelaxing: "",
          restless: "",
          afraid: "",
          annoyed: "",
        });
        console.log("data saved");
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      toast.error("Failed to Save")
      console.error("Error submitting form:", error);
    } finally {
      setShowCallBtn(false)
      setShowModal(false)
    }
  };
  const handleBackClick = () => {
    navigate(-1); 
  };
  return (
    <>
  <div className="col-md-12 mt-4 inner-page-heading-wrapper">
    <button onClick={handleBackClick} className="win-back-btn">
      <span><i className="bi bi-chevron-left"></i> {t('back')}</span>
    </button>
    <h2 className="page-heading">{t("BhHeadertitle")}</h2>
    <p>{isHighmarkPortal ? t("highmarkbhsubtitle") : t("Bhsubtitle")}</p>
  </div>

  <div>
    <form onSubmit={handlePopUp}>
      <div className="row">
        <div className="col-md-12 mt-4">
          <label>{isHighmarkPortal ? t('highmarkbhlabel') : t("Bhlabel")}</label>
          <textarea
            name="freetext"
            placeholder="Enter your text here..."
            value={formData.freetext}
            onChange={(e) => handleDropdownChange("freetext", e.target.value)}
            className="win-form-control textarea-control-w-100"
          />
          {errors.freetext && (
            <div className="form-field-error-message">{errors.freetext}</div>
          )}

          <h3 className="page-heading-bold-primary-20 mt-4">{t("bhheader2")}</h3>
          <p>{t("bhpara")}</p>

          <div className="col-md-12 mt-4">
            {[{
              name: "interest",
              label: t("bhinterest")
            }, {
              name: "depressed",
              label: t("bhdepressed")
            }, {
              name: "trobulesleep",
              label: t("bhStayingAsleep")
            }, {
              name: "tired",
              label: t("bhFeelingTired")
            }, {
              name: "overeating",
              label: t("bhPoorAppetite")
            }, {
              name: "feelingbad",
              label: t("bhFeelingBad")
            }, {
              name: "troubleconcentrating",
              label: t("bhTroubleConcentrating")
            }, {
              name: "Movingspeakingslowly",
              label: t("bhSpeakingSoSlowly")
            }, {
              name: "hurtingyourself",
              label: t("bhThoughtsThat")
            }]
            .slice(0, isHighmarkPortal ? undefined : 2)
            .map(({ name, label }) => (
              <div key={name} className="row mb-4 align-items-center">
                <div className="col-md-4">
                  <label>{label}<span className="text-primary-color">*</span></label>
                </div>
                <div className="col-md-4">
                  <CustomDropdown
                    options={dropdownValues}
                    selectedOption={formData[name]}
                    onChange={(value) => handleDropdownChange(name, value)}
                    label={label}
                    placeholder={t("bhselection")}
                    searchable={true}
                  />
                </div>
                <div className="col-md-4">
                  {errors[name] && (
                    <div className="form-field-error-message">{errors[name]}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="col-md-12 mt-4">
          <h3 className="page-heading-bold-primary-20 mt-4">{t("bhexcessive")}</h3>
          <p>{t("bhpara2")}</p>
          {[{
            name: "nervous",
            label: t("bhnervous")
          }, {
            name: "controlworrying",
            label: t("bhstop")
          }, {
            name: "worrying",
            label: t("bhthings")
          }, {
            name: "troublerelaxing",
            label: t("bhrelax")
          }, {
            name: "restless",
            label: t("bhrestless")
          }, {
            name: "afraid",
            label: t("bhawful")
          }, {
            name: "annoyed",
            label: t("bhannoyed")
          }].map(({ name, label }) => (
            <div key={name} className="row mb-4 align-items-center">
              <div className="col-md-4">
                <label>{label}<span className="text-primary-color">*</span></label>
              </div>
              <div className="col-md-4">
                <CustomDropdown
                  options={dropdownValues}
                  selectedOption={formData[name]}
                  onChange={(value) => handleDropdownChange(name, value)}
                  label={label}
                  placeholder={t("bhselection")}
                  searchable={true}
                />
              </div>
              <div className="col-md-4">
                {errors[name] && (
                  <div className="form-field-error-message">{errors[name]}</div>
                )}
              </div>
            </div>
          ))}

          <div className="row mb-4 align-items-center">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <button className="win-btn-primary model-popup-btn" type="submit">
                {t("submit")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    {showModal && (
      <ErrorModal
        show={showModal}
        message={modalMessage}
        onClose={showCallBtn ? handleSubmit : undefined}
        showCall={showCallBtn}
        isOkay={!showCallBtn}
        onOkay={handleSubmit}
      />
    )}
    {showFetchErrorModal && (
      <ErrorModal
        show={showFetchErrorModal}
        message={fetchErrorMessage}
        onClose={() => setShowFetchErrorModal(false)}
        isOkay={true}
        onOkay={() => setShowFetchErrorModal(false)}
        showCall={true}
      />
    )}
  </div>
</>
  )
};

export default BHAssessmentForm;
